import { saveAs } from 'file-saver';
import { LoadingService } from '../../../shared/services/loading.service';
import { LoanApplicationService } from '../../services/loan-application.service';
import { ChecklistService } from '../../../setup/services';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Message } from 'primeng/components/common/api';
@Component({
  selector: 'app-defferal-management',
  templateUrl: './defferal-management.component.html',
})
export class DefferalManagementComponent implements OnInit {
  displayUpload: boolean;
  binaryFile: string;
  selectedDocumentName: string;
  loanApplicationId: number;
  msgs: Message[] = [];
  today = new Date();
  singleDeferredAndWaivedDocument: any[];
  deferredAndWaivedDocument: any[];
  displayDeferralDetails: boolean = false;
  displayExtentDeferral: boolean = false;
  displayDeferralProvided: boolean = false;
  conditionId: number;
  deferredDocument: string;
  extensionReason: string;
  extensionDate: string;
  hasDocument: boolean;
  deferralDocumentUpload: any[];
  viewUpload: any;
  constructor(private loadingService: LoadingService, private loanAppService: LoanApplicationService, private checklistService: ChecklistService, ) { }

  ngOnInit() {
    this.getAllDeferralChecklist();
  }
  viewDetails(row, evt) {
    evt.preventDefault();
    this.conditionId = row.conditionId;
    this.loanApplicationId = row.loanApplicationId;
    this.getDeferralChecklistByConditionId(this.conditionId)
    this.getConditionPrecedentDocumentUpload(this.conditionId);
    this.displayDeferralDetails = true;
  }
  getAllDeferralChecklist() {
    this.loadingService.show();
    this.checklistService.getAllDeferralChecklist().subscribe((response: any) => {
      this.deferredAndWaivedDocument = response.result;
      this.loadingService.hide();
    });
  }
  getDeferralChecklistByConditionId(conditionId) {
    this.loadingService.show();
    this.checklistService.getDeferralChecklistByConditionId(conditionId).subscribe((response: any) => {
      this.singleDeferredAndWaivedDocument = response.result;
      this.deferredDocument = this.singleDeferredAndWaivedDocument[0].condition;
      this.loadingService.hide();
    });
  }
  showDeferralExtention() {
    this.displayExtentDeferral = true;
  }
  submitDeferralExtention() {
    if (this.today > new Date(this.extensionDate)) {
      this.showSuccess('info', `Extended date cannot be less than today's date`);
      return;
    }
    if (this.hasDocument) {

    }
    let body = {
      conditionId: this.conditionId,
      reason: this.extensionReason,
      deferedDate: this.extensionDate
    };
    this.loadingService.show();
    this.checklistService.extendChecklistDeferralDate(body).subscribe((res: any) => {
      if (res.success === true) {
        if (this.uploadFileTitle != null) {
          this.uploadFile();
        }
        this.getDeferralChecklistByConditionId(this.conditionId)
        this.loadingService.hide();
        this.showSuccess('success', res.message);
        this.extensionReason = null;
        this.extensionDate = null;
        this.displayExtentDeferral = false;
      } else {
        this.loadingService.hide();
        this.showSuccess('error', res.message);
      }
    }, (err) => {
      this.showSuccess('error', JSON.stringify(err));
    });
  }

  showDeferralProvided() {
    this.displayDeferralProvided = true;
  }
  submitDeferralProvided() {
    this.loadingService.show();

    let body = {
      conditionId: this.conditionId,
    };
    this.checklistService.updateProvidedChecklist(body).subscribe((res: any) => {
      if (res.success === true) {
        if (this.uploadFileTitle != null) {
          this.uploadFile();
        }
        this.getAllDeferralChecklist();
        this.loadingService.hide();
        this.showSuccess('success', res.message);
        this.conditionId = null;
        this.displayDeferralProvided = false;
        this.displayDeferralDetails = false;
      } else {
        this.loadingService.hide();
        this.showSuccess('error', res.message);
      }
    }, (err) => {
      this.loadingService.hide();
      this.showSuccess('error', JSON.stringify(err));
    });
  }

  // file upload
  uploadFileTitle: string = null;
  files: FileList;
  file: File;

  @ViewChild('fileInput', {static: false}) fileInput: any;
  onFileChange(event) {
    this.files = event.target.files;
    this.file = this.files[0];
    this.uploadFileTitle = this.file.name;
  }
  fileExtention(name: string) {
    var regex = /(?:\.([^.]+))?$/;
    return regex.exec(name)[1];
  }
  uploadFile() {
    if (this.file != undefined || this.uploadFileTitle != null) {
      let body = {
        conditionId: this.conditionId,
        loanApplicationId: this.loanApplicationId,
        fileName: this.file.name,
        fileExtension: this.fileExtention(this.file.name),
        physicalFileNumber: 'n/a',
        physicalLocation: 'n/a',
      };
      this.loadingService.show();
      this.checklistService.uploadFile(this.file, body).then((val: any) => {
        this.uploadFileTitle = null;
        this.fileInput.nativeElement.value = "";
        this.showSuccess('success', 'Uploaded Successfully...');
        this.loadingService.hide();
      }, (error) => {
        this.loadingService.hide(1000);
        this.showSuccess('error', 'Upload not Successful...');
      });
    }
  }
  getConditionPrecedentDocumentUpload(conditionId) {
    this.checklistService.getConditionPrecedentDocumentUpload(conditionId).subscribe((data: any) => {
      if (data.success == true) {
        this.deferralDocumentUpload = data.result;
      } else {
        this.showSuccess('info', 'No upload found for this deferral');
      }
    });
  }
  viewDocument(documentId) {
    this.selectedDocumentName = null;
    this.binaryFile = null;
    this.loadingService.show()
    this.checklistService.ViewConditionPrecedentDocumentUpload(documentId).subscribe((data: any) => {
      this.viewUpload = data.result;
      if (this.viewUpload != undefined) {
        if (['jpg', 'jpeg', 'png'].indexOf(this.viewUpload.fileExtension.toLowerCase()) > -1) {
          this.selectedDocumentName = this.viewUpload.fileName;
          this.binaryFile = this.viewUpload.fileData;
          this.displayUpload = true;
        }
        if (['doc', 'docx', 'pdf', 'xls', 'xlsx'].indexOf(this.viewUpload.fileExtension.toLowerCase()) > -1) {
          this.DownloadDocument(this.viewUpload);
        }
      } else {
        this.showSuccess('info', 'No upload found for this checklist');
      }
      this.loadingService.hide()
    });
  }
  DownloadDocument(doc: any) {
    if (doc != null) {
      this.binaryFile = doc.fileData;
      let documentName = doc.documentTitle;
      let myDocExtention = doc.fileExtension;
      var byteString = atob(this.binaryFile);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var bb = new Blob([ab]);
      if (myDocExtention == 'jpg' || myDocExtention == 'jpeg') {
        var file = new File([bb], documentName + '.jpg', { type: 'image/jpg' });
      }
      if (myDocExtention == 'png' || myDocExtention == 'png') {
        var file = new File([bb], documentName + '.png', { type: 'image/png' });
      }
      if (myDocExtention == 'pdf' || myDocExtention == '.pdf') {
        var file = new File([bb], documentName + '.pdf', { type: 'application/pdf' });
      }
      if (myDocExtention == 'xls' || myDocExtention == 'xlsx') {
        var file = new File([bb], documentName + '.xlsx', { type: 'application/vnd.ms-excel' });
      }
      if (myDocExtention == 'doc' || myDocExtention == 'docx') {
        var file = new File([bb], documentName + '.doc', { type: 'application/msword' });
      }
      saveAs(file)
    }
  }
  showSuccess(type, message) {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: 'FinTrak Credit 360', detail: message });
  }
}
